<script setup>
import { toRefs, ref } from 'vue'
import { useRoute } from 'vue-router'
import { ServerStore } from '../pinia/Server.js'
const route = useRoute()
const Server = ServerStore()
const props = defineProps({
  data: Object
})
const {data} = toRefs(props)

function getBackground() {
    if(data.value.thumb_version == 0)
        return "https://cdn.nightriderz.world/images/website/district-thumb/" + data.value.districtid + ".jpg"
    else
        return 'https://cdn.nightriderz.world/images/website/crew/' + data.value.crewid + '-thumb-v' + data.value.thumb_version + '.png'
}
</script>

<template>
    <RouterLink :to="'/crew/headquarters/' + data.crewid" class="crew-card-wrapper">
        <v-card class="crew-card" elevation="2">
            <!-- Image de fond avec format conservé -->
            <div class="crew-image-container">
                <div 
                    class="crew-image" 
                    :style="{
                        backgroundImage: `url(${getBackground()})`,
                        backgroundSize: '350px auto'
                    }"
                ></div>
            </div>
            
            <!-- Informations du crew -->
            <div class="crew-content">
                <div class="crew-main-info">
                    <div class="crew-tag-badge" :style="{ backgroundColor: data.color }">
                        {{ data.tag }}
                    </div>
                    <h3 class="crew-title">{{ data.name }}</h3>
                </div>
                
                <div class="crew-stats">
                    <div class="stat-item">
                        <v-icon size="16" color="warning">mdi-trophy</v-icon>
                        <span class="stat-value">Lvl {{ data.level }}</span>
                    </div>
                    <div class="stat-divider"></div>
                    <div class="stat-item">
                        <v-icon size="16" color="info">mdi-account-group</v-icon>
                        <span class="stat-value">{{ number_format(data.nb_member) }}</span>
                    </div>
                    <div class="stat-divider"></div>
                    <div class="stat-item">
                        <v-icon size="16" color="success">mdi-star</v-icon>
                        <span class="stat-value">{{ number_format(data.nb_points) }}</span>
                    </div>
                </div>
            </div>
        </v-card>
    </RouterLink>
</template>

<style scoped>
.crew-card-wrapper {
    text-decoration: none;
    display: block;
    margin: 20px;
}

.crew-card {
    width: 364px;
    height: 264px;
    border-radius: 8px;
    overflow: hidden;
    background: #1a1d29;
    border: 2px solid rgba(255, 255, 255, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    display: flex;
    flex-direction: column;
}

.crew-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
}

/* Container de l'image - Format conservé à l'identique */
.crew-image-container {
    flex-shrink: 0;
    overflow: hidden;
}

.crew-image {
    width: 350px;
    height: 180px;
    margin: 7px auto 0 auto;
    border-radius: 4px;
    background-repeat: repeat;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.crew-card:hover .crew-image {
    transform: scale(1.08);
}

/* Contenu du crew */
.crew-content {
    flex: 1;
    padding: 12px 14px 10px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: linear-gradient(to bottom, #1a1d29 0%, #151821 100%);
}

.crew-main-info {
    display: flex;
    align-items: center;
    gap: 10px;
}

.crew-tag-badge {
    padding: 4px 10px;
    border-radius: 6px;
    font-weight: 700;
    font-size: 11px;
    color: white;
    text-transform: uppercase;
    letter-spacing: 1px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    flex-shrink: 0;
}

.crew-title {
    font-size: 16px;
    font-weight: 700;
    color: white;
    text-transform: uppercase;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0.5px;
}

/* Statistiques */
.crew-stats {
    display: flex;
    align-items: center;
    gap: 8px;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.9);
}

.stat-label {
    color: rgba(255, 255, 255, 0.6);
    font-weight: 500;
}

.stat-value {
    font-weight: 600;
    color: white;
}

.stat-divider {
    width: 1px;
    height: 14px;
    background: rgba(255, 255, 255, 0.2);
}
</style>